import { Map, type MapProps } from '@vis.gl/react-google-maps'
import { Box, Flex, Text } from '@chakra-ui/react'
import { LuTriangleAlert as AlertTriangle } from 'react-icons/lu'
import { GOOGLE_MAPS_ENABLED, GOOGLE_MAPS_MAP_ID, PERU_CENTER, PERU_ZOOM } from './config'

export interface KMapProps extends MapProps {
  children?: React.ReactNode
}

/**
 * Wrapper de `<Map>` con los defaults de la app: Map ID (para AdvancedMarker),
 * gestos "greedy" (zoom con rueda sin Ctrl), satélite+etiquetas por defecto y
 * centro en Perú. Cuando no hay clave configurada muestra un aviso en vez de un
 * mapa roto.
 */
export function KMap({ children, ...props }: KMapProps) {
  if (!GOOGLE_MAPS_ENABLED) {
    return (
      <Flex h="100%" w="100%" align="center" justify="center" bg="blackAlpha.50" p={6}>
        <Flex direction="column" align="center" gap={2} color="gray.500" textAlign="center">
          <AlertTriangle size={22} />
          <Text fontSize="sm" fontWeight="600">
            Mapa no disponible
          </Text>
          <Text fontSize="xs" maxW="260px">
            Falta configurar la clave de Google Maps (VITE_GOOGLE_MAPS_API_KEY).
          </Text>
        </Flex>
      </Flex>
    )
  }

  return (
    <Box h="100%" w="100%">
      <Map
        mapId={GOOGLE_MAPS_MAP_ID}
        defaultCenter={PERU_CENTER}
        defaultZoom={PERU_ZOOM}
        mapTypeId="hybrid"
        gestureHandling="greedy"
        disableDefaultUI={false}
        clickableIcons={false}
        style={{ width: '100%', height: '100%' }}
        {...props}
      >
        {children}
      </Map>
    </Box>
  )
}
